import type { FC } from "react";

import { AlertBanner } from "@jti/core-components/components/AlertBanner";
import type { ButtonButtonProps, ButtonLinkProps } from "@jti/core-components/components/Button";
import { Button } from "@jti/core-components/components/Button";
import { isServerSide } from "@jti/fe-common";

import styles from "../../ContactForm.module.scss";

type SuccessFieldProp = {
  label: string;
  value?: string;
};

type ButtonBehaviorProps = Pick<ButtonLinkProps, "href"> | Required<Pick<ButtonButtonProps, "onClick">>;

export type SuccessScreenProps = {
  successScreenTitle?: string;
  successScreenDescription?: string;
  successScreenButtonLabel: string;
  successScreenAlertButtonLabel: string;
  successFields: SuccessFieldProp[];
  successScreenHref: string;
  resetContactForm: () => void;
};

export const SuccessScreen: FC<SuccessScreenProps> = ({
  successScreenTitle,
  successScreenButtonLabel,
  successFields,
  successScreenHref,
  successScreenAlertButtonLabel,
  successScreenDescription,
  resetContactForm,
}) => {
  const getButtonBehaviorProps = (): ButtonBehaviorProps =>
    isServerSide() || window.location.pathname !== successScreenHref
      ? {
          href: successScreenHref,
        }
      : {
          onClick: resetContactForm,
        };

  return (
    <div className={styles.successScreenContainer}>
      <AlertBanner
        tone="success"
        title={successScreenTitle}
        description={successScreenDescription}
        actions={[{ label: successScreenAlertButtonLabel }]}
      />
      <div className={styles.successFieldsContainer} data-testid="success-fields-container">
        {successFields.map(({ label, value }) => (
          <div key={label} className={styles.successFieldContainer} data-testid="success-field-container">
            <div className={styles.successFieldLabel}>{label}:</div>
            <div className={styles.successFieldContent}>{value}</div>
          </div>
        ))}
      </div>
      {successScreenButtonLabel && (
        <div className={styles.buttonWrapper}>
          <Button variant="secondary" {...getButtonBehaviorProps()}>
            {successScreenButtonLabel}
          </Button>
        </div>
      )}
    </div>
  );
};
